import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 20px;
`;

const ModalTitle = styled.h2`
  font-size: 1.5rem;
  color: #333;
  margin: 0 0 20px 0;
  text-align: center;
`;

const ModalMessage = styled.p`
  text-align: center;
  margin-bottom: 10px;
  color: #333;
  font-size: 14px;
  line-height: 1.5;
`;

const ShippingMessage = styled.p`
  text-align: center;
  margin-bottom: 20px;
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const Button = styled.button<{ primary?: boolean }>`
  padding: 10px 16px;
  border: ${props => props.primary ? 'none' : '1px solid #E5E7EB'};
  border-radius: 6px;
  background-color: ${props => props.primary ? '#042B41' : 'white'};
  color: ${props => props.primary ? 'white' : '#333'};
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  
  &:hover {
    background-color: ${props => props.primary ? '#0A3D5A' : '#F9FAFB'};
  }
`;

interface ShippingConfirmationDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ShippingConfirmationDialog: React.FC<ShippingConfirmationDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onCancel}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalTitle>Confirm Submission</ModalTitle>
        <ModalMessage>Are u sure you want to proceed?</ModalMessage>
        <ShippingMessage>Have you charged Supplier and BWA shipping?</ShippingMessage>
        <ButtonGroup>
          <Button onClick={onCancel}>Go back</Button>
          <Button primary onClick={onConfirm}>Submit</Button>
        </ButtonGroup>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ShippingConfirmationDialog;

